import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/13_waterfall/13_waterfall"
 * Contains 1 texture(s)
 */
export class Mobile13WaterfallAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/13_waterfall/13_waterfall';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '13_waterfall.jpg'
    ] as const;
}
